<template>
  <section id="report">
    <div class="mb-4 card">
      <div class="d-sm-flex justify-content-between p-2 pb-3">
        <h4 class="mb-sm-0 pt-2">
          <a href="/dashboard">Home Page</a><span>/</span><span>Dashboard</span><span>/</span><b>Bourdon Report</b>
        </h4>
      </div>

      

    </div>
    <div class="tool-box d-flex flex-row">
      <b class="mx-2">Type of Report: </b>
      <select style="width: 100px;height: 50px" v-model="typeOfReport" @change="changeTypeOfReport()">
        <option value="detailed">Detailed</option>
        <option value="summary">Summary Report</option>
      </select>


      <b class="ml-4 mr-2">Type of Person: </b>
      <select style="width: 100px;height: 50px" v-model="typeOfPerson" v-if="typeOfReport=='detailed'" @change="changeTypeOfPerson()">
        <option value="student">Student</option>
        <option value="group">Group</option>
        <option value="schools">Schools</option>
      </select>
      <select style="width: 100px;height: 50px" v-model="typeOfPerson" v-if="typeOfReport=='summary'" @change="changeTypeOfPerson()">
        <option value="group">Group</option>
        <option value="schools">Schools</option>
      </select>

      <select multiple class="mx-2" style="width: 200px;height:120px" v-model="selectedGroups" v-if="typeOfPerson=='group'" >
        <option selected disabled> -- Multi Select Groups -- </option>
        <option
          v-for="(group, index) in totalGroups"
          :key="index"
          :value="group.group"
        >
          Group{{ group.group }}
        </option>
      </select>

      <select multiple class="mx-2" style="width: 200px;height:120px" v-model="selectedClasses" v-if="typeOfPerson=='schools'" >
        <option selected disabled> -- Multi Select Groups -- </option>
        <option
          v-for="(classs, index) in classes"
          :key="index"
          :value="classs"
        >
          {{ classs }}
        </option>
      </select>
      <input type="text" v-model="searchStudentName" v-if="typeOfPerson=='student'" style="height: 50px;" placeholder="Search Student Name">

      <div class="ml-4">
        <p><b>Filter Dates:</b></p>
        <select v-model="filterDates">
          <option value="only_date">Only Date</option>
          <option value="date_range">Date Range</option>
        </select>
      </div>

      <div class="mx-2" v-if="filterDates=='date_range'">
        <div>
          <label>Start Date:</label>
          <input type="date" v-model="startDate"/>
        </div>
        <div>
          <label class="mr-2">End Date:</label>
          <input type="date" v-model="endDate"/>
        </div>
      </div>

      <div class="mx-2" v-if="filterDates=='only_date'">
        <div>
          <input type="date" v-model="startDate"/>
        </div>
      </div>

      <button class="mx-4" style="height: 50px; width: 100px"
      @click.prevent="searchBourdonRepoart()"
      v-if="students.length > 0 && startDate != ''" >Search</button>
    </div>


    <div class="mt-2 table-responsive" v-if="bourdonTests.length > 0">
      <table class="table table-bordered" v-if="typeOfReport=='detailed'">
        <thead class="thead-dark">
          <tr>
            <th>Name</th>
            <th v-if="typeOfPerson=='group'">Group</th>
            <th v-if="typeOfPerson=='schools'">Class</th>
            <th>Digits viewed (Max:1600)</th>
            <th>Lines viewed  (Max:40)</th>
            <th>Selected digits (Max:1600)</th>
            <th>Rights (Max:200)</th>
            <th>Wrongs (Max:200)</th>
            <th>Missed (Max:200)</th>
            <th>Attention speed <span @click="showInfoModal('Attention speed')">( <i class="fas fa-info"></i> )</span></th>
            <th>Mental productivity <span @click="showInfoModal('Mental productivity')">( <i class="fas fa-info"></i> )</span></th>
            <th>Concentration % <span @click="showInfoModal('Concentration %')">( <i class="fas fa-info"></i> )</span></th>
            <th>Test time</th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="test in bourdonTests" :key="test._id">
              <td>{{test.name}}</td>
              <td v-if="typeOfPerson=='group'">{{test.group}}</td>
              <td v-if="typeOfPerson=='schools'">{{test.class}}</td>
              <td>{{test.nn.toFixed(2)}}</td>
              <td>{{test.cc.toFixed(2)}}</td>
              <td>{{test.mm.toFixed(2)}}</td>
              <td>{{test.ss.toFixed(2)}}</td>
              <td>{{test.oo.toFixed(2)}}</td>
              <td>{{test.pp.toFixed(2)}}</td>
              <td>{{test.aa.toFixed(2)}}</td>
              <td>{{test.ee.toFixed(2)}}</td>
              <td>{{test.kk.toFixed(2)}}</td>
              <td>{{test.t.toFixed(2)}}</td>
          </tr>
        </tbody>
      </table>
      <table class="table table-bordered" v-if="typeOfReport=='summary'">
        <thead class="thead-dark">
          <tr>
            <th v-if="typeOfPerson=='group'">Group</th>
            <th v-if="typeOfPerson=='schools'">Class</th>
            <th>Digits viewed (Max:1600)</th>
            <th>Lines viewed  (Max:40)</th>
            <th>Selected digits (Max:1600)</th>
            <th>Rights (Max:200)</th>
            <th>Wrongs (Max:200)</th>
            <th>Missed (Max:200)</th>
            <th>Attention speed <span @click="showInfoModal('Attention speed')">( <i class="fas fa-info"></i> )</span></th>
            <th>Mental productivity <span @click="showInfoModal('Mental productivity')">( <i class="fas fa-info"></i> )</span></th>
            <th>Concentration % <span @click="showInfoModal('Concentration %')">( <i class="fas fa-info"></i> )</span></th>
            <th>Test time</th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="test in bourdonTests" :key="test._id">
              <td>{{test.group}}</td>
              <td>{{test.nn.toFixed(2)}}</td>
              <td>{{test.cc.toFixed(2)}}</td>
              <td>{{test.mm.toFixed(2)}}</td>
              <td>{{test.ss.toFixed(2)}}</td>
              <td>{{test.oo.toFixed(2)}}</td>
              <td>{{test.pp.toFixed(2)}}</td>
              <td>{{test.aa.toFixed(2)}}</td>
              <td>{{test.ee.toFixed(2)}}</td>
              <td>{{test.kk.toFixed(2)}}</td>
              <td>{{test.t.toFixed(2)}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <mdb-container>
      <!-- trigger modal button -->

      <!-- cookie modal -->
      <mdb-modal :show="modalInfo" removeBackdrop centered>
        <mdb-modal-body>
          <h4 class="font-weight-normal">
            {{ infoTitle }}
          </h4>
          <p>
            {{ infoDescription }}
          </p>          
          <button
              type="button"
              class="btn btn-danger btn-sm float-right"
              data-dismiss="modal"
              @click="modalInfo = false"
            >
              Close
            </button>
        </mdb-modal-body>
      </mdb-modal>
    </mdb-container>
  </section>
</template>

<script>
import axios from "axios";
// import { mdbRow, mdbCol, mdbCard, mdbCardBody, mdbIcon,  mdbModal,
//     mdbModalBody,} from "mdbvue";
// import StudentStatusReport from './StudentStatusReport';
import { mdbContainer, mdbModal, mdbModalBody } from "mdbvue";

export default {
  name: "BourdonReport",
  components: {
    // mdbRow,
    // mdbCol,
    // mdbCard,
    // mdbCardBody,
    // mdbIcon,
    mdbModal,
    mdbModalBody,
    mdbContainer
    // StudentStatusReport
  },
  data() {
    return {
      totalGroups: [],
      classes: JSON.parse(localStorage.getItem("classes")),
      students: [],
      bourdonTests: [],
      fastAdminToken: localStorage.getItem("fastAdminToken"),
      typeOfReport: 'detailed', // summary
      typeOfPerson: 'student', // group, schools
      searchStudentName: '',
      selectedGroups: [],
      selectedClasses: [],
      filterDates: 'only_date', // date_range
      startDate: '',
      endDate: '',
      modalInfo: false,
      infoTitle: '',
      infoDescription: ''
    };
  },

  methods: {
    changeTypeOfReport() {
      if (this.typeOfReport == 'summary') {
        this.typeOfPerson="group";
      } else {
        this.typeOfPerson="student";
      }
      this.changeTypeOfPerson();
    },

    changeTypeOfPerson() {
      this.selectedGroups = [];
      this.selectedClasses = [];
      this.searchStudentName = '';
      this.startDate = '';
      this.endDate = '';
    },

    searchBourdonRepoart() {
      this.bourdonTests = [];
      let studentIds = [];
      let startingDate = new Date(this.startDate);
      let endingDate = new Date(this.startDate);
      endingDate.setDate(startingDate.getDate() + 1);
      let today = new Date();
      let tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);

      if(startingDate.getTime() >= tomorrow.getTime()) {
        this.$toast.open({
          message: "Error: Please select correct end date",
          type: "error",
        });
        return;
      }

      if (this.filterDates == 'date_range') {
        endingDate = new Date(this.endDate);
        if(startingDate.getTime() >= endingDate.getTime()) {
          this.$toast.open({
            message: "Error: Please select correct end date",
            type: "error",
          });
          return;
        }
      }

      for (let index in this.students) {
        if (this.typeOfPerson == 'student') {
          let searchingName = this.students[index].first_name + ' ' + this.students[index].last_name + ' ' + this.students[index].name;
          searchingName = searchingName.toLowerCase();
          if (searchingName.includes(this.searchStudentName)) {
            studentIds.push(this.students[index]._id);
          }
        } else if (this.typeOfPerson == 'group'){
          if (this.selectedGroups.includes(this.students[index].group)) {
            studentIds.push(this.students[index]._id);
          }
        } else {
          if (this.selectedClasses.includes(this.students[index].class)) {
            studentIds.push(this.students[index]._id);
          }
        }
      }

      if (studentIds.length > 0) {
        this.$toast.open({
          message: "Processing : Loading Data Please Wait...",
          type: "info",
        });

        const config = {
          headers: {
            Authorization: "Bearer " + this.fastAdminToken,
            "Content-Type": "application/json",
          },
        };

        axios
          .post(this.$apiURI + "/account/bourdon/search",
          {
            studentIds: studentIds,
            startAt: startingDate.getTime(),
            endAt: endingDate.getTime()
          },
          config)
          .then((response) => {
            if (response.data.error) {
              this.$toast.open({
                message: "Error : " + response.data.message,
                type: "error",
              });
            } else {
              // eslint-disable-next-line no-console
              if (Object.keys(response.data.data).length > 0) {

                if (this.typeOfPerson == 'schools') {
                  this.students.sort((a, b) => (a.class??'').localeCompare((b.class??'')));
                } else {
                  this.students.sort((a, b) => (a.group??'').localeCompare((b.group??'')));
                }

                if (this.typeOfReport == 'detailed') {
                  for (let i in this.students) {
                    if (studentIds.includes(this.students[i]._id)) {
                      if (response.data.data[this.students[i]._id]) {
                        let reportItem = {...response.data.data[this.students[i]._id]};
                        reportItem['name'] = `${this.students[i].first_name} ${this.students[i].last_name}`;
                        reportItem['group'] = this.students[i].group;
                        reportItem['class'] = this.students[i].class;
                        this.bourdonTests.push(reportItem);
                      }
                    }
                  }
                } else {
                  if (this.typeOfPerson == 'group') {
                    for (let j in this.selectedGroups) {
                      let reportItem1 = {t:0, nn:0, cc:0, n:0, mm:0, ss:0, pp:0, oo:0, aa:0, ee:0, au:0, kk:0, group: this.selectedGroups[j]};
                      let count = 0;
                      for (let i in this.students) {
                        if (this.students[i].group == this.selectedGroups[j]) {
                          if (response.data.data[this.students[i]._id]) {
                            count++;
                            let studentReportItem1 = response.data.data[this.students[i]._id];
                            reportItem1.t += studentReportItem1.t;
                            reportItem1.nn += studentReportItem1.nn;
                            reportItem1.cc += studentReportItem1.cc;
                            reportItem1.n += studentReportItem1.n;
                            reportItem1.mm += studentReportItem1.mm;
                            reportItem1.ss += studentReportItem1.ss;
                            reportItem1.pp += studentReportItem1.pp;
                            reportItem1.oo += studentReportItem1.oo;
                            reportItem1.aa += studentReportItem1.aa;
                            reportItem1.ee += studentReportItem1.ee;
                            reportItem1.au += studentReportItem1.au;
                            reportItem1.kk += studentReportItem1.kk;
                          }
                        }
                      }

                      if (count > 0) {
                        reportItem1.t /= count;
                        reportItem1.nn /= count;
                        reportItem1.cc /= count;
                        reportItem1.n /= count;
                        reportItem1.mm /= count;
                        reportItem1.ss /= count;
                        reportItem1.pp /= count;
                        reportItem1.oo /= count;
                        reportItem1.aa /= count;
                        reportItem1.ee /= count;
                        reportItem1.au /= count;
                        reportItem1.kk /= count;
                        this.bourdonTests.push(reportItem1);
                      }
                    }
                  } else {
                    for (let j in this.selectedClasses) {
                      let reportItem2 = {t:0, nn:0, cc:0, n:0, mm:0, ss:0, pp:0, oo:0, aa:0, ee:0, au:0, kk:0, group: this.selectedClasses[j]};
                      let count = 0;
                      for (let i in this.students) {
                        if (this.students[i].class == this.selectedClasses[j]) {
                          if (response.data.data[this.students[i]._id]) {
                            count++;
                            let studentReportItem2 = response.data.data[this.students[i]._id];
                            reportItem2.t += studentReportItem2.t;
                            reportItem2.nn += studentReportItem2.nn;
                            reportItem2.cc += studentReportItem2.cc;
                            reportItem2.n += studentReportItem2.n;
                            reportItem2.mm += studentReportItem2.mm;
                            reportItem2.ss += studentReportItem2.ss;
                            reportItem2.pp += studentReportItem2.pp;
                            reportItem2.oo += studentReportItem2.oo;
                            reportItem2.aa += studentReportItem2.aa;
                            reportItem2.ee += studentReportItem2.ee;
                            reportItem2.au += studentReportItem2.au;
                            reportItem2.kk += studentReportItem2.kk;
                          }
                        }
                      }

                      if (count > 0) {
                        reportItem2.t /= count;
                        reportItem2.nn /= count;
                        reportItem2.cc /= count;
                        reportItem2.n /= count;
                        reportItem2.mm /= count;
                        reportItem2.ss /= count;
                        reportItem2.pp /= count;
                        reportItem2.oo /= count;
                        reportItem2.aa /= count;
                        reportItem2.ee /= count;
                        reportItem2.au /= count;
                        reportItem2.kk /= count;
                        this.bourdonTests.push(reportItem2);
                      }
                      
                    }
                  }
                }
              }
            }
          })
          .catch((error) => {
            this.$toast.open({
              message: "Error : " + error.response.data.message,
              type: "error",
            });
          });
      } else {
        this.$toast.open({
          message: "Error: No students",
          type: "error",
        });
      }
    },

    showInfoModal(title) {
      this.infoTitle = title;
      if (title == 'Attention speed') {
        this.infoDescription = 'Digits seen / Test Time (s)'
      } else if (title == 'Mental productivity') {
        this.infoDescription = 'Digits seen * Successes / (Successes + Mistakes + Missed)'
      } else if (title == 'Concentration %') {
        this.infoDescription = '( Selected - Mistakes ) / Total of the special Number * 100'
      }
      this.modalInfo = true;
    }
  },

  mounted() {
    this.$toast.open({
      message: "Processing : Loading Dashboard Data Please Wait...",
      type: "info",
    });

    const config = {
      headers: {
        Authorization: "Bearer " + this.fastAdminToken,
        "Content-Type": "application/json",
      },
    };
      
    axios
      .get(this.$apiURI + "/groups", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          let groups = response.data.data.groups;
          this.totalGroups = groups;

          axios
          .get(this.$apiURI + "/account/students", config)
          .then((response) => {
            if (response.data.error) {
              this.$toast.open({
                message: "Error : " + response.data.message,
                type: "error",
              });
            } else {
              // eslint-disable-next-line no-console
              // console.log(response.data.data.teachers)
              this.students = response.data.data.students;
            }
          })
          .catch((error) => {
            this.$toast.open({
              message: "Error : " + error.response.data.message,
              type: "error",
            });
          });

        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.cascading-admin-card {
  margin: 20px 0;
  background: #1c2331 !important;
}

.btn:hover {
  color: #fff;
}

.cascading-admin-card .admin-up {
  margin-left: 4%;
  margin-right: 4%;
  margin-top: -20px;
  background: #1c2331 !important;
}

.cascading-admin-card .admin-up .fas,
.cascading-admin-card .admin-up .far {
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.2), 0 2px 13px 0 rgba(0, 0, 0, 0.19);
  padding: 1rem;
  font-size: 1rem;
  color: #fff;
  text-align: left;
  margin-right: 1rem;
  border-radius: 3px;
  background: #1c2331 !important;
}

.cascading-admin-card .admin-up .data {
  float: right;
  margin-top: 2rem;
  text-align: right;
}

.admin-up .data p {
  color: #999999;
  font-size: 12px;
}

.classic-admin-card .card-body {
  color: #fff;
  margin-bottom: 0;
  padding: 0.9rem;
}

.classic-admin-card .card-body p {
  font-size: 13px;
  opacity: 0.7;
  margin-bottom: 0;
}

.classic-admin-card .card-body h4 {
  margin-top: 10px;
}
</style>
